// extracted by mini-css-extract-plugin
export var ctaLink = "CtaLink-module--ctaLink--98feb";
export var focusVisible = "CtaLink-module--focus-visible--9ef3f";
export var outlineDark = "CtaLink-module--outlineDark--a05fe";
export var outlineLight = "CtaLink-module--outlineLight--d1c21";